import { createRouter, createWebHistory, createWebHashHistory  } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/HomePage.vue'),  // 首页
    // meta: { title: '艺梦导航-艺考填报系统' } // 添加 meta 字段
  },
  {
    path: '/Simulation/:id?',
    name: 'Simulation',
    component: () => import('../views/SimulationNew.vue')  // 模拟填报
  },
  {
    path: '/Aibotquery',
    name: 'Aibotquery',
    component: () => import('../views/Aibotquery.vue')  // 模拟填报
  },
  {
    path: '/FindUniversity',
    name: 'FindUniversity',
    component: () => import('../views/FindUniversity.vue')  // 找大学
  },
  {
    path: '/FindMajor',
    name: 'FindMajor',
    component: () => import('../views/FindMajor.vue')   // 查专业
  },
  {
    path: '/DivideSections',
    name: 'DivideSections',
    component: () => import('../views/DivideSections.vue')  // 一分一段
  },
  {
    path: '/Comprehensive',
    name: 'Comprehensive',
    component: () => import('../views/Comprehensive.vue')   // 算综合分
  },
  {
    path: '/Information',
    name: 'Information',
    component: () => import('../views/Information.vue')   // 政策指导
  },
  {
    path: '/UsageGuide',
    name: 'UsageGuide',
    component: () => import('../views/UsageGuide.vue')   // 使用指南
  },
  {
    path: '/PersonalCenter',
    name: 'PersonalCenter',
    component: () => import('../views/PersonalCenter.vue')  // 个人中心
  },
  {
    path: '/MajorDetails',
    name: 'MajorDetails',
    component: () => import('../views/MajorDetails.vue')  // 专业详情
  },
  {
    path: '/SchoolDetails',
    name: 'SchoolDetails',
    component: () => import('../views/SchoolDetails.vue')  // 院校详情
  },
  {
    path: '/NewDetails',
    name: 'NewDetails',
    component: () => import('../views/NewDetails.vue')  //文章详情
  },
  {
    path: '/VolunteerDetail',
    name: 'VolunteerDetail',
    component: () => import('../views/VolunteerDetail.vue')  // 志愿表详情
  },
  {
    path: '/MySchoolExam',
    name: 'MySchoolExam',
    component: () => import('../views/MySchoolExam.vue')  // 我的校考
  },
  {
    path: '/AcceptanceLine',
    name: 'AcceptanceLine',
    component: () => import('../views/AcceptanceLine.vue')  // 校考合格线
  },
  {
    path: '/Postgraduate',
    name: 'Postgraduate',
    component: () => import('../views/Postgraduate.vue')  // 艺考考研
  },
  {
    path: '/CulturalDivision',
    name: 'CulturalDivision',
    component: () => import('../views/CulturalDivision.vue')  // 测文化分呢
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 动态设置标题
router.beforeEach((to, from, next) => {
  const title = to.meta.title;
  if (title) {
    document.title = title;
  } else {
    document.title = '艺梦导航-PC版-艺考志愿填报系统-艺体填报系统'; // 设置一个默认标题
  }
  next();
});

export default router
